module.exports = __webpack_public_path__ + "img/Tadaa.9477f33f.svg";